import { Link } from "react-router-dom";
import { useLocalePath, useT } from "../i18n";
import { PAGE_IMAGERY } from "../config/siteImagery";
import { Seo } from "../components/Seo";
import { ShellLayout } from "../components/ShellLayout";

export default function ShellPage({ page }) {
  const t = useT();
  const lp = useLocalePath();
  return (
    <>
      <Seo title={t(`pages.${page}.title`)} description={t(`pages.${page}.description`)} path={page} />
      <ShellLayout
        testId={`shell-page-${page}`}
        crumb={t(`nav.${page}`)}
        eyebrow={t("ui.comingSoon")}
        title={t(`pages.${page}.title`)}
        image={PAGE_IMAGERY[page]}
      >
        <p className="mt-8 max-w-md text-white/70" data-testid="coming-soon-message">{t("shell.title")}</p>
        <p className="mt-2 max-w-md text-sm text-white/45">{t("shell.body")}</p>
        <div className="mt-12 flex flex-col gap-3 sm:flex-row sm:gap-4">
          <Link to={lp()} className="btn btn-light" data-testid="shell-back-home">{t("ui.backHome")}</Link>
          {page !== "contact" && (
            <Link to={lp("contact")} className="btn btn-ghost-light" data-testid="shell-contact">{t("ui.contactUs")}</Link>
          )}
        </div>
      </ShellLayout>
    </>
  );
}
